import { ValidationErrorMessage } from 'react-admin';

export const removeTags = (str: string): string => {
  if (!str) {
    return '';
  }
  const newStr = str
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
  return newStr;
};

export const aboutTextAreaValidate = (
  value: string,
  raffle: any,
  length: any
) => {
  const errors: ValidationErrorMessage = {
    message: '',
    args: { message: '' },
  };
  if (!value) {
    return (errors.message = 'Required');
  }
  if (removeTags(value).length > length.data) {
    return (errors.message = `Must be ${length.data} characters or less`);
  }
  return undefined;
};
export const aboutTextAreaValidateNotRequired = (
  value: string,
  raffle: any,
  length: any
) => {
  const errors: ValidationErrorMessage = {
    message: '',
    args: { message: '' },
  };

  if (removeTags(value).length > length.data) {
    return (errors.message = `Must be ${length.data} characters or less`);
  }
  return undefined;
};

export const notificationTextAreaValidate = (value: string) => {
  const errors: ValidationErrorMessage = {
    message: '',
    args: { message: '' },
  };
  if (!value) {
    return (errors.message = 'Required');
  }
  if (removeTags(value).length > 200) {
    return (errors.message = 'Must be 200 characters or less');
  }
  return undefined;
};
